import { render, staticRenderFns } from "./dashboard-app.vue?vue&type=template&id=aadf67b4"
import script from "./dashboard-app.vue?vue&type=script&lang=js"
export * from "./dashboard-app.vue?vue&type=script&lang=js"
import style0 from "./dashboard-app.vue?vue&type=style&index=0&id=aadf67b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports